import { AfterViewInit, Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { environment } from '@environment/environment';

@Directive({
  selector: 'img[appSrc]'
})
export class FaviconLoadDirective implements OnInit {
  @Input() appSrc: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    ) {}

	ngOnInit (): void {
    let newPath = `${environment.faviconApi}${this.appSrc}&client=VFE&size=32`;
    this.renderer.setAttribute(this.el.nativeElement,"src",newPath);
	}
}